import React from 'react';
import L from 'leaflet';
import { TileLayer, LayersControl } from 'react-leaflet';
import { OS_MAPS_LOGO_URL, MAPBOX_LOGO_WHITE, MAPBOX_ATTRIBUTION, OS_MAPS_ATTRIBUTION, OPEN_STREET_MAP_ATTRIBUTION, OPEN_TOPO_MAP_ATTRIBUTION } from './AttributionUtil';

const { BaseLayer, } = LayersControl

const OFFLINE_MAPS = window.env.REACT_APP_OFFLINE_MAPS === "true";

export class BaseLayersUtil {

    static getBaseLayers(t, servicesURLs) {

        let baseLayersInfo = { mapLayers: [], startingZoom: 18 }; // OSM starting zoom
        let defaultBaseMapChecked = true;

        if (OFFLINE_MAPS) {

            const offlineUrl = window.env.REACT_APP_OFFLINE_MAP_URL + "/tile/{z}/{x}/{y}.png";

            baseLayersInfo.mapLayers.push(
                <BaseLayer checked={true} name={t("map.openStreetMap")}>
                    
                    <TileLayer
                        attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                        url={ offlineUrl }
                        maxZoom={18}
                        minZoom={3}
                    />
                </BaseLayer>);

            return baseLayersInfo;
        }

        // Push the default base layers at the end, as its checked status depends on the logic above
        // Set the zoom level for the default map. This will get updated when map leyers are changed
        baseLayersInfo.mapLayers.push(
            <BaseLayer checked={true} name={t("map.openStreetMap")}>
                <TileLayer
                    attribution={OPEN_STREET_MAP_ATTRIBUTION}
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    referrerPolicy='origin-when-cross-origin'
                    maxZoom={18}
                    minZoom={3}
                />
            </BaseLayer>);

        baseLayersInfo.mapLayers.push(
            <BaseLayer name={t("map.openTopoMap")}>
                <TileLayer
                    url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                    attribution={OPEN_TOPO_MAP_ATTRIBUTION}
                    transparent={true}
                    referrerPolicy='origin-when-cross-origin'
                />
            </BaseLayer>);


        if (servicesURLs.some(s => s.layer === "openseamap_base")) {

            baseLayersInfo.mapLayers.push(
                <BaseLayer name={"Open Sea Map"}>
                    <TileLayer
                        url="https://t2.openseamap.org/tile/{z}/{x}/{y}.png"
                        attribution={OPEN_STREET_MAP_ATTRIBUTION}
                        transparent={true}
                        referrerPolicy='origin-when-cross-origin'
                    />
                </BaseLayer>);
        }

        // If any of the layers configured are in UK - provide OS base map as a possible selection
        if (servicesURLs.some(s => s.layer === "os_base")) {

            // If OS maps added - default to these
            defaultBaseMapChecked = false

            // Select the OS map, if the default base map is not to be pre-selected
            baseLayersInfo.mapLayers.push(
                <BaseLayer name={"OS Road map"}>
                    <TileLayer
                        url="/maps/os/raster/Road_3857/{z}/{x}/{y}.png"
                        minZoom={7}
                        attribution={OS_MAPS_ATTRIBUTION}
                        logo={OS_MAPS_LOGO_URL}
                    />
                </BaseLayer>
            );
            baseLayersInfo.mapLayers.push(
                <BaseLayer name={"OS Outdoor map"}>
                    <TileLayer
                        url="/maps/os/raster/Outdoor_3857/{z}/{x}/{y}.png"
                        minZoom={7}
                        attribution={OS_MAPS_ATTRIBUTION}
                        logo={OS_MAPS_LOGO_URL}
                    />
                </BaseLayer>
            );
            baseLayersInfo.mapLayers.push(
                <BaseLayer name={"OS Light map"}>
                    <TileLayer
                        url="/maps/os/raster/Light_3857/{z}/{x}/{y}.png"
                        minZoom={7}
                        attribution={OS_MAPS_ATTRIBUTION}
                        logo={OS_MAPS_LOGO_URL}
                    />
                </BaseLayer>
            );
        }

        baseLayersInfo.mapLayers.push(
            <BaseLayer name={t("map.satelliteMap")}>
                <TileLayer
                    url="/maps/mapbox/{z}/{x}/{y}"
                    attribution={MAPBOX_ATTRIBUTION}
                    transparent={true}
                    tileSize={512}
                    zoomOffset={-1}
                    crossOrigin={true}
                    logo={MAPBOX_LOGO_WHITE}
                />
            </BaseLayer>);

        return baseLayersInfo;

    }

}